const loadJobs = (gsap, smoother, ScrollTrigger) => {
  
  function getUrlVars() {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
  }
  
  // Use tdt for testing: https://boards-api.greenhouse.io/v1/boards/tdt/departments?render_as=tree
  var jobCount = 'https://boards-api.greenhouse.io/v1/boards/videoamp/jobs',
      jobListings = 'https://boards-api.greenhouse.io/v1/boards/videoamp/departments?render_as=tree',
      filter = $('.jobs-filter-wrap'),
      wrap = $('.open-positions'),
      jobsContainer = $('.open-jobs-container'),
      noJobs = $('.no-openings'),
      filters = [];

  $.ajax({
    url: jobCount,
    type: 'GET',
    success: function (count) {

      var checkJobCount = count.meta.total;

      if (checkJobCount > 0) {

        gsap.set(filter, { display: 'block' });
        gsap.set(wrap, { display: 'block' });
        getJobs();

      } else {

        gsap.set(wrap, { display: 'block' });
        gsap.to(wrap, { duration: 0.6, y: 0, autoAlpha: 1, onComplete: function() {

          noJobs.delay(300).fadeIn('fast');
          ScrollTrigger.refresh();

        } });

      }

    }
  });

  function getJobs() {

    $.ajax({
      url: jobListings,
      type: 'GET',
      success: function (data) {

        var departments = data.departments;

        gsap.to(filter, { duration: 0.6, y: 0, autoAlpha: 1 });
        gsap.to(wrap, { duration: 0.6, y: 0, autoAlpha: 1 });

        // Loop through Departments
        $.each(departments, function (key, value) {

          var deptName = value.name, // Department name
            deptId = value.id, // Department ID,
            j = key,
            deptSlug = deptName.replace(/\s+/g, '-').toLowerCase(); // Department name formatted as a slug

          // Check if the department has any open positions
          if (value.jobs.length >= 1 || value.children.length >= 1) {

            // Append Departments to a filter dropdown
            $('.filter .filter-dept').append('<option value="' + deptName + '">' + deptName + '</option>');

            jobsContainer.append(`
            <div class="department-block all" data-department-id="` + deptId + `" data-department="` + deptName + `">
              <h3 class="department-title">` + deptName + `</h3>
              <div class="jobs-wrap" data-department-id="` + value.id + `"></div>
            </div>
          `);

            var deptJobs = value.jobs, // Get Jobs object
              deptChildren = value.children; // Get Jobs of children departments

            $.each(deptJobs, function (key, value) {

              var jobLocationName = value.location.name, // Get the location of the job
                jobLocationSlug = jobLocationName.replace(/\s+/g, '-').toLowerCase(), // Location name formatted as a slug
                stringCleaned = jobLocationName.replace(/[.,\s]/g, '').toLowerCase(), // Remove commas and to lowercase
                stringFormatted = stringCleaned.replace(/;/g, ' '); // Replace semicolons with a space

              filters.push(jobLocationName); // Push location name to an array for the filter drop down

              $('.department-block[data-department-id="' + deptId + '"] .jobs-wrap').append(`
              <div class="job-block" data-job-id="` + value.id + `" data-location="` + jobLocationName + `">
                <a href="/job/?gh_jid=` + value.id + `">
                  <div>
                    <div class="job-content">
                      <h4 class="job-title">` + value.title + `</h4>
                      <p class="job-location p-sm">` + jobLocationName + `</p>
                    </div>
                    <div class="apply">
                      <div class="apply-btn" href="/job/?gh_jid=` + value.id + `">Apply</div>
                    </div>
                  </div>
                </a>
              </div>
            `);

            });

            // Loop through children Departments
            $.each(deptChildren, function (key, value) {

              var childrenJobs = value.jobs; // Create jobs object for open positions of children departments

              // Check if child department has any open positions
              if (childrenJobs.length >= 1) {

                // Loop through jobs of child department
                $.each(childrenJobs, function (key, item) {

                  // Push location name to an array for the filter drop down
                  filters.push(item.location.name);

                  var stringCleaned = item.location.name.replace(/[.,\s]/g, '').toLowerCase(), // Remove commas and to lowercase
                    stringFormatted = stringCleaned.replace(/;/g, ' '); // Replace semicolons with a space

                  $('.department-block[data-department-id="' + deptId + '"] .jobs-wrap').append(`
                  <div class="job-block" data-job-id="` + item.id + `" data-location="` + item.location.name + `">
                    <a href="/job/?gh_jid=` + item.id + `">
                      <div>
                        <div class="job-content">
                          <h4 class="job-title">` + item.title + `</h4>
                          <p class="job-location p-sm">` + item.location.name + ` <span>|</span> ` + value.name + `</p>
                        </div>
                        <div class="apply">
                          <div class="apply-btn" href="/job/?gh_jid=` + item.id + `">Apply</div>
                        </div>
                      </div>
                    </a>
                  </div>
                `);

                });

              }

            });

          }

        });

        // Remove duplicate locations from filter list
        var locationsUnique = filters.filter(function (loc, index) {
          return filters.indexOf(loc) >= index;
        });

        // Add each unique location to filter dropdown
        $.each(locationsUnique, function (key, loc) {

          $('.filter .filter-location').append('<option value="' + loc + '">' + loc + '</option>');

        });

        // Hide any departments that return empty due to children departments being present and remove the dropddown item for them
        $('.department-block').each(function() {

          var deptBlock = $(this),
              deptName = deptBlock.attr('data-department'),
              deptDrop = $('.filter-dept option[value="' + deptName + '"]'),
              deptJobs = deptBlock.find('.jobs-wrap');

          if (deptJobs.get(0).children.length == 0) {

            deptBlock.remove();
            deptDrop.remove();

          }

        });

      },
      complete: function () {
        
        ScrollTrigger.refresh();

        var deparmentBlock = $('.department-block'),
            currentDepartmentList = [];

        gsap.to(deparmentBlock, { duration: 0.6, y: 0, autoAlpha: 1, stagger: 0.15, onComplete: checkHash });

        function checkHash() {

          deparmentBlock.each(function() {

            var $this = $(this),
                departmentTitle = $this.attr('data-department'),
                breakDepartmentTitle = departmentTitle.replace(/(\s+)(?![A-Za-z0-8])/g, '').toLowerCase(),
                cleanDepartmentTitle = breakDepartmentTitle.replace(/\s+/g, '-');

            currentDepartmentList.push(cleanDepartmentTitle);
            $this.attr('data-slug', cleanDepartmentTitle);

          });

          var urlHash = getUrlVars()["dept"];

          if (currentDepartmentList.indexOf(urlHash) > -1) {
            gsap.to(smoother, {
              scrollTop: smoother.offset($('div[data-slug="'+urlHash+'"]'), "top 80px"),
              duration: 1
            });
          }

        }

      }
    });

  }
  
}

export {
  loadJobs
};